module.exports = __webpack_public_path__ + "static/ztig_logo-18c2b3a2075eb7eab0bdd4173a634b6e.png";